// Importar páginas
import Login from './Pages/Login';
import Menu from './Pages/Menu';

// Protected
import ProtectedRoute from './Auth/ProtectedRoute';
// Navigate
import { Navigate } from 'react-router-dom';

export const routes = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/Menu",
    element: (
      <ProtectedRoute>
        <Menu />
      </ProtectedRoute>
    ),
  },
  // Ruta 404: cualquier otra cosa te manda al login
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];
